import { render, staticRenderFns } from "./Municipality.vue?vue&type=template&id=4bffdb96&"
import script from "./Municipality.vue?vue&type=script&lang=js&"
export * from "./Municipality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports